module.exports = __webpack_public_path__ + "img/shili_01@3x.4b039cb5.png";